module.exports = __webpack_public_path__ + "media/images/simulation/ic_pdf-08e0eb3c7377b6c62a189ad8be2c08a2.svg";